module.exports =
  '_PROFILE':
    'TITLE_PREVIEW': 'プロフィール公開画面プレビュー'
    'TITLE': 'プロフィール'
    'BIRTH_DATE': '誕生日'
    'GENDER': '性別'
    'MALE': '男性'
    'FEMALE': '女性'
    'COUNTRY': 'お住まい'
    'RECENT_ROUNDS': '総ラウンド数'
    'BEST_SCORE': 'ベストスコア'
    'AVG_SCORE': '平均スコア'
    'SCORE_THIS_YEAR': '今年のスコア'
    'TOP_5_HEADING': 'よく行くゴルフ場　TOP5'
    'LATEST_ROUNDS': '最近のラウンド情報'
    'SEE_MORE': 'もっと見る'
    'PHOTOS_HEADING': 'フォトスコアカード'
    'CLUB_SETTING': 'クラブセット'
    'USE_BALL': '使用ボール'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/profile/i18n/ja.coffee